import { Box, Typography } from '@mui/material';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { LOGIN_ROUTE } from '../../utils/routes';
import { resetForgetPasswordState } from '../../redux/forgetPassword/forgetPasswordSlice';
import StyledButton from '../Common/StyledButton';
import { brandTagKey } from '../../config/constants';

const Icon = styled.img`
  height: 48px;
  width: 48px;
`;

function ForgetPasswordSuccess() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const goBackToLogin = () => {
    const brandTag = localStorage.getItem(brandTagKey);
    navigate(brandTag ? `${LOGIN_ROUTE}/${brandTag}` : LOGIN_ROUTE);
    dispatch(resetForgetPasswordState());
  };

  return (
    <>
      <Icon src="/assets/icons/check-circle-large.svg" />
      <Box gap="16px" display="flex" flexDirection="column">
        <Typography variant="title2Bold" textAlign="center" color="primary">
          {t('forgetPassword.passwordUpdated')}
        </Typography>

        <Typography variant="bodyRegular" textAlign="center" color="primary" fontWeight={500}>
          {t('forgetPassword.passwordUpdatedDesc')}
        </Typography>
      </Box>

      <StyledButton onClick={goBackToLogin} endIcon>
        {t('forgetPassword.goBackToLogin')}
      </StyledButton>
    </>
  );
}

export default ForgetPasswordSuccess;
